import React from 'react'
import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const ButtonBack = ({path}) => {
    
    const history = useHistory();
        const onHome = () => {
        history.push(path)
    };
  return (
     <div>
        <div className='inicio' onClick={onHome}>
            <ArrowBackIcon /> Regresar
        </div>
    </div>
  )
}   